export default "__VITE_ASSET__CU9iwwo9__"